export const GET_SPENDING_INSIGHTS_REQUEST = 'GET_SPENDING_INSIGHTS_REQUEST';
export const GET_SPENDING_INSIGHTS_SUCCESS = 'GET_SPENDING_INSIGHTS_SUCCESS';
export const GET_SPENDING_INSIGHTS_FAILURE = 'GET_SPENDING_INSIGHTS_FAILURE';
export const SET_SPENDING_INSIGHTS = 'SET_SPENDING_INSIGHTS';
